import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { ErrorState } from "../components/ErrorState";
import { TripDetailContainer } from "../components/trip-detail";

export function TripDetail() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <DashboardLayout title={t("trips.detail")}>
        <ErrorState error={new Error(t("trips.notFound"))} />
      </DashboardLayout>
    );
  }

  return <TripDetailContainer tripId={id} />;
}
